<script>
  import Button from '@components/buttons/button.svelte'
  import { cn } from '@lib/utils'
  import { colors } from '@lib/utils/colors'

  let { tag, size = "sm", itemClass, variant = "base", class: className, onSelect, path, ...buttonProps } = $props()

  let baseClasses = "leading-none rounded-xl font-sans tracking-[0.2px]"
  
  let sizeClasses = {
    xxs: "text-[10px] px-[6px] py-[1px]",
    xs: "text-[11px] px-[8px] py-[1px]",
    sm: "text-[12px] px-[8px] py-[2px]",
    md: "text-[13px] px-[11px] py-[3px]",
    lg: "text-[14px] px-[13px] py-[4px]",
    xl: "text-[15px] px-[15px] py-[5px]"
  }
  
  let colorKey = $derived(tag?.color || "gray")
  
  let classes = $derived(cn(
    baseClasses,
    sizeClasses[size],
    colors[colorKey][variant],
    onSelect ? (colors[colorKey]?.hover || colors.gray.hover) : "",
    itemClass
  ))

</script>

<div class="flex items-center gap-1 flex-wrap">
  {#if onSelect || path}
    <Button variant="naked" text={tag.name} class={cn(classes, className)} {path} onclick={onSelect ? () => onSelect(tag) : null} {...buttonProps} />
  {:else}
    <span class={cn(classes, className)}>{tag.name}</span>
  {/if}
</div>
